import {Toggle} from '@rocket-ui/components';
import {FC, ReactNode} from 'react';
import {SelectedBank} from '../../model';
import {StepLayout} from 'features/registration';
import {BankIcon} from '../components/BankListPanel/BankIcon';
import styles from './PaymentReviewStep.module.css';

export type PaymentReviewField = {
	label: string;
	value: ReactNode;
};

const PRIMARY_HINT_OFF =
	'Эти реквизиты будут использоваться в случае невозможности оплатить по основному способу';

const PRIMARY_HINT_ON =
	'Будем отправлять деньги сюда. Если не получится — на другие добавленные реквизиты (при их наличии)';

type CommissionBlock = {
	value: string;
	hint: string;
};

type Props = {
	fields: PaymentReviewField[];
	bank?: SelectedBank | null;
	commission?: CommissionBlock;
	isPrimary: boolean;
	showPrimaryToggle?: boolean;
	onPrimaryChange: (value: boolean) => void;
};

export const PaymentReviewStep: FC<Props> = ({
	fields,
	bank,
	commission,
	isPrimary,
	showPrimaryToggle = true,
	onPrimaryChange,
}) => {
	return (
		<StepLayout variant="fill">
			<StepLayout.Title>Давайте сверим</StepLayout.Title>

			<StepLayout.Content className={styles.content}>
				<dl className={styles.fields}>
					{fields.map((field) => (
						<div key={field.label} className={styles.field}>
							<dt className={styles.label}>{field.label}</dt>
							<dd className={styles.value}>{field.value}</dd>
						</div>
					))}
				</dl>

				{bank ? (
					<div className={styles.bankRow}>
						<BankIcon bank={bank} className={styles.bankIcon} />
						<span className={styles.bankName}>{bank.shortName}</span>
					</div>
				) : null}

				{commission ? (
					<div className={styles.commissionBlock}>
						<div className={styles.field}>
							<p className={styles.label}>Комиссия</p>
							<p className={styles.value}>{commission.value}</p>
						</div>
						<p className={styles.commissionHint}>{commission.hint}</p>
					</div>
				) : null}

				{showPrimaryToggle ? (
					<div className={styles.primaryBlock}>
						<div className={styles.primaryRow}>
							<p className={styles.primaryLabel}>Сделать основным способом для получения выплат</p>
							<Toggle value={isPrimary} onChange={onPrimaryChange} />
						</div>
						<p className={styles.primaryHint}>{isPrimary ? PRIMARY_HINT_ON : PRIMARY_HINT_OFF}</p>
					</div>
				) : null}
			</StepLayout.Content>
		</StepLayout>
	);
};
